import { render, staticRenderFns } from "./FichesIncidentStatistiques.vue?vue&type=template&id=0865f91c&"
import script from "./FichesIncidentStatistiques.vue?vue&type=script&lang=ts&"
export * from "./FichesIncidentStatistiques.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports